import { makeStyles } from "@material-ui/core/styles";
import styled from "styled-components";

export const useStyles = makeStyles((theme) => ({
  root: {
    fontFamily: `${theme.typography.secondary}, Sans-serif, Arial`,
    fontWeight: 600,
  },
  text: {
    fontFamily: `${theme.typography.main}, Sans-serif, Arial`,
  },
  seeMore: {
    marginTop: theme.spacing(3),
  },
  hide: {
    fontFamily: `${theme.typography.main}, Sans-serif, Arial`,

    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  hide1: {
    fontFamily: `${theme.typography.main}, Sans-serif, Arial`,

    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  tableRow: {
    "&:hover": {
      background: "rgb(230,230,230)",
      cursor: "pointer",
    },
  },
  pendig: {
    color: "gray",
    fontWeight: "bold",
  },
  paid: {
    color: "rgb(25,109,235)",
    fontWeight: "bold",
  },
  verified: {
    color: "rgb(0, 204, 204)",
    fontWeight: "bold",
  },
  invoiced: {
    color: "rgb(0, 255, 0)",
    fontWeight: "bold",
  },
  shipping: {
    color: "rgb(204, 204, 0 )",
    fontWeight: "bold",
  },
  done: {
    color: "rgb(0, 153, 0)",
    fontWeight: "bold",
  },
  rejected: {
    color: "rgb(204, 0, 0 )",
    fontWeight: "bold",
  },
  table: {
    padding: theme.spacing(2),
  },
  rowItem: {
    "&:hover, &:focus": {
      cursor: "pointer",
      backgroundColor: theme.palette.primary.light,
    },
  },

  resetBtn: {
    width: "100%",
  },
  heading: {
    fontFamily: `${theme.typography.main}, Sans-serif, Arial`,
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 600,
  },

  headerTop: {
    backgroundColor: theme.palette.primary.backgroundSecondary,
    display: "flex",
    flexDirection: "column",
    alignItems: "left",
    padding: "0.5rem",
    color: "white",
    width: "100%",
  },
  header: {
    // borderRadius: "0 0 30px 30px",
    backgroundColor: theme.palette.primary.backgroundSecondary,
    color: "white",
    tableLayout: "fixed",
    width: "100%",
    boxShadow: "0 4px 15px 0 rgb(0 0 0 / 10%), 0 6px 20px 0 rgb(0 0 0 / 19%)",
  },
  searchBar: {
    fontSize: "0.75rem",
    display: "flex",
    padding: "5px 32px"
  },

  filterExp: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  searchField: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    position: "relative",
    [theme.breakpoints.up("md")]: {
      width: "90%",
    },
  },
  option: {
    color: "black",
  },
  sortField: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
  },
  searchDatePicker: {
    width: "100%",
    border: "transparent",
    color: "whitesmoke",
    borderBottom: "1px solid rgb(100, 100, 100)",
    outline: "none",
    "&:hover, &:focus": {
      cursor: "pointer",
      borderBottom: "2px solid whitesmoke",
    },
    background: "transparent",
    height: "25px",
  },

  searchSelect: {
    width: "100%",
    border: "transparent",
    color: "whitesmoke",
    borderBottom: "1px solid rgb(100, 100, 100)",
    outline: "none",
    "&:hover, &:focus": {
      cursor: "pointer",
      borderBottom: "2px solid whitesmoke",
    },
    background: "transparent",
    height: "25px",
  },
  filterInput: {
    color: "whitesmoke",
    "&:hover, &:focus": {
      cursor: "pointer",
      borderBottom: "2px solid whitesmoke",
    },
  },

  listitemtable: {
    tableLayout: "fixed",
    width: "100%",
    transition: "background 300ms",
    borderRadius: "0 0 4px 4px",
  },
  listItem: {
    height: "50px",
    borderRadius: "0 0 4px 4px ",
    "&:hover": {
      cursor: "pointer",
      background: "rgb(220, 220, 220)",
    },
  },
  tableCell: {
    fontFamily: `${theme.typography.main}, Sans-serif, Arial`,
  },
  hideMd: {
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  hideXs: {
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  showXs: {
    display: "inherit",
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
}));

export const ReportListWrapper = styled.div`
  tablelayout: fixed;
  width: 100%;
  transition: background 300ms;
  background-color: whitesmoke;
  border-radius: 0 0 4px 4px;
  box-shadow: 0 4px 15px 0 rgb(0 0 0 / 10%);
`;

